import { typographyStyles } from './Typography.styles';
import type { TypographyVariant, TypographyAlign } from './Typography.types';
import { cn } from '../../../utils/className';

export const getTypographyClasses = (
  variant?: TypographyVariant,
  align?: TypographyAlign,
  className?: string
): string => {
  return cn(
    typographyStyles.base,
    variant && typographyStyles.variants[variant],
    align && typographyStyles.align[align],
    className
  );
};